export default __webpack_public_path__ + "static/media/Pilz-Button-Nicht-Essbar.ce2524a7.png";